export default __webpack_public_path__ + "static/media/logo.81a22dca.png";